import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      token: null,
      didAutoLogout: false,
      id: null,
      username: null,
      // `name` mirrors users.name. For a client login this equals the
      // clientName the order rows are tagged with — used by the dashboard
      // socket subscription to listen on the client-scoped room.
      name: null,
      role: null,
      vendor: null,
      payInStatus: null,
      payOutStatus: null,
      // Per-branch override of the default subadmin manual-approve
      // restriction. Set from the JWT at login. Drives whether the
      // payin "Approve" button is rendered for a subadmin — the
      // backend gate re-reads from the DB so a stale `true` here
      // can't actually authorise an action.
      canApprovePayinManually: false,
      // Per-vendor self-serve client management (18062026). Granted by
      // superadmin via the vendor edit form. Backend re-verifies on each
      // request — this state only drives sidebar + router gating.
      canManageClients: false,
      // Partial-payout branch settings (20092026). UI affordance only.
      canPickupPartialPayout: false,
      canPartialApprovePayout: true,
      isSupporting: false,
      // Effective permission keys for a SUPPORTING user (empty for main
      // users — they are never permission-gated on the client). Drives
      // sidebar + router gating so a supporting user only sees/reaches what
      // they can actually use; the backend remains the authority.
      permissions: [],
      // Set true immediately after a supporting-user login so the router's
      // first redirect (e.g. dashboard not allowed → first permitted page)
      // is SILENT. Consumed (cleared) on the first supporting-user guard
      // pass; any later restricted-page hit then shows a notice. Not persisted.
      justLoggedIn: false,
      // Transient message shown as a global toast when a supporting user is
      // bounced off a page they can't access (null = nothing to show).
      accessNotice: null,
      exp: null,
      iat: null,
    };
  },
  mutations,
  actions,
  getters,
};
